import { ToastOptions, toast as LibToast } from 'react-toastify'

export const useToast = () => {
  return {
    toast: (message: string, options?: ToastOptions) => LibToast(message, options),
  }
}